import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin, List } from "antd";
import SubjectItem from "./SubjectItem";
import { ACTION_TYPE } from "reducers/actionType";
import { BackButton } from "components/ui/MasterButton";

import SummaryFooter from "components/footers/SummaryFooter";

class AllSubjectsList extends Component {
  handleToggleSubject = idNum => {
    const newId = idNum.toString();
    const {
      userRecSubs,
      userAddSubs,
      userOthSubs,
      recommendedSubjects,
      otherSubjects
    } = this.props;
    if (recommendedSubjects.includes(newId)) {
      const newSelectedItems = Array.from(userRecSubs);
      if (newSelectedItems.find(id => newId === id) > -1) {
        newSelectedItems.splice(newSelectedItems.indexOf(newId), 1);
      } else {
        newSelectedItems.push(newId);
      }
      this.props.dispatch({
        type: ACTION_TYPE.pickRecSubs,
        data: { userRecSubs: newSelectedItems }
      });
    }

    // in other subjects
    else if (otherSubjects.includes(newId)) {
      const newSelectedItems = Array.from(userOthSubs);
      if (newSelectedItems.find(id => newId === id) > -1) {
        newSelectedItems.splice(newSelectedItems.indexOf(newId), 1);
      } else {
        newSelectedItems.push(newId);
      }
      this.props.dispatch({
        type: ACTION_TYPE.pickOthSubs,
        data: { userOthSubs: newSelectedItems }
      });
    } else {
      const newSelectedItems = Array.from(userAddSubs);
      if (newSelectedItems.find(id => newId === id) > -1) {
        newSelectedItems.splice(newSelectedItems.indexOf(newId), 1);
      } else {
        newSelectedItems.push(newId);
      }
      this.props.dispatch({
        type: ACTION_TYPE.pickAddSubs,
        data: { userAddSubs: newSelectedItems }
      });
    }
  };

  isSelected = id => {
    const myId = id.toString();
    const { userAddSubs, userOthSubs, userRecSubs } = this.props;
    return (
      userAddSubs.includes(myId) ||
      userOthSubs.includes(myId) ||
      userRecSubs.includes(myId)
    );
  };

  render() {
    if (!this.props.input) return <Spin />;

    const { userRecSubs, userOthSubs, userAddSubs } = this.props;

    const subjects = this.props.input.subjects;
    let listItems = {};
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    alphabet.forEach(letter => {
      Object.values(subjects).forEach(item => {
        if (item.name.toUpperCase().startsWith(letter, 0)) {
          if (!(letter in listItems)) {
            listItems[letter] = [item];
          } else {
            listItems[letter].push(item);
          }
        }
      });
    });

    for (let letter in listItems) {
      listItems[letter].sort((a, b) => (a.name < b.name ? -1 : 1));
    }

    const subjectsSelected =
      userRecSubs.length > 0 ||
      userAddSubs.length > 0 ||
      userOthSubs.length > 0;

    return (
      <>
        <div className="regular-padding">
          <BackButton navlink="/summary" />
          <h1>All Subjects</h1>

          {Object.keys(listItems).map(letter => (
            <div key={letter} className="margin-bottom">
              <h1>{letter}</h1>
              <List
                className="all-subjects-list"
                itemLayout="horizontal"
                dataSource={listItems[letter]}
                renderItem={sub => (
                  <SubjectItem
                    subject_num={sub.subject_num}
                    name={sub.name}
                    category={sub.category}
                    units={sub.units}
                    prerequisite_of={null}
                    handleToggleSubject={this.handleToggleSubject}
                    subjectItemSelected={this.isSelected(sub.subject_num)}
                    showSelect={true}
                  />
                )}
              />
            </div>
          ))}
        </div>
        <SummaryFooter
          back={true}
          backNavlink="summary"
          enable={subjectsSelected}
          nextNavlink="summary/atar-eligible"
        />
      </>
    );
  }
}

const mapStateToProps = store => {
  const { input } = store.inputReducer;

  const { userAddSubs } = store.pickAddSubReducer;
  const { userOthSubs } = store.pickOthSubReducer;
  const { userRecSubs } = store.pickRecSubReducer;
  const { recommendedSubjects } = store.recommendedSubjectsReducer;
  const { otherSubjects } = store.otherSubjectsReducer;
  const { additionalSubjects } = store.additionalSubjectsReducer;
  return {
    input: input,
    // Recommeded
    userRecSubs,
    userOthSubs,
    userAddSubs,
    recommendedSubjects,
    otherSubjects,
    additionalSubjects
  };
};

export default connect(mapStateToProps)(AllSubjectsList);
